'use strict';

import React from 'react';
import {browserHistory} from 'react-router';
import BusinessBrief from './BusinessBriefComponent'
import API from 'sources/API';
import UserStore from 'stores/UserStore';
import UserActions from 'actions/UserActions';
import Navigator from './NavigatorComponent';

require('styles/Business.scss');

class AgentComponent extends React.Component {
  constructor(props) {
    super(props);
    let userStore = UserStore.getState()
    this.state = {
      agent: userStore.agent,
      articles: userStore.agentArticles
    }
    this.onAgentChange = this.onAgentChange.bind(this)
    this.goto = this.goto.bind(this)
  }
  goto(path){
    browserHistory.push(path)
  }
  componentDidMount() {
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
            window.wx.config(json);
        }
      })
    }
    UserStore.listen(this.onAgentChange)
    UserActions.clearArticles()
    UserActions.fetchAgent(this.props.params.id)
    UserActions.fetchAgentArticles(this.props.params.id)

    window.scroll(0,0);
    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillUnmount() {
    UserStore.unlisten(this.onAgentChange)
  }
  onAgentChange(agent){
    this.setState({
      agent: agent.agent,
      articles: agent.agentArticles
    })

    let businessName = agent.agent.agent_name;
    let businessDesc = agent.agent.agent_desc;
    let cover = agent.agent.agent_small_avatar
    window.wx.ready(()=>{
      window.wx.onMenuShareTimeline({
        title: `${businessName}-${businessDesc}`,
        link: `${location.href}?type=share`,
        imgUrl: encodeURI(cover||'https://img.xiaodiqiu.cn/share.png')
      });
      window.wx.onMenuShareAppMessage({
        title: `${businessName}-${businessDesc}`,
        desc: `${businessDesc}`,
        link: `${location.href}?type=share`,
        imgUrl: encodeURI(cover||'https://img.xiaodiqiu.cn/share.png'),
        type: 'link'
      });
    });

    let title = businessName;
    let desc = businessDesc;
    window.changeMetaForSEO(title,desc);
  }
  handleTextChange(event) {
    let state = {};
    state[event.target.name] = event.target.value;
    this.setState(state);
  }
  render(){
    let business = {
      name: this.state.agent.agent_name,
      small_avatar: this.state.agent.agent_small_avatar,
      summary: this.state.agent.agent_desc,
      ad_url: this.state.agent.agent_ad_url
    }
  	return (
  	  <div className="Business-component">
        {this.state.agent.is_agent?(
  	    <BusinessBrief article={{}} business={business} />
        ):(<div className="text-gray width-all height-200 lh-200 fz-14 text-center">~~还不是合作代理~~</div>)}
        <div className="content mb-60">
          <div className="nav">奇趣行程</div>
          {this.state.articles.map(article => (
            <div key={article._id} onClick={this.goto.bind(null, `/agent/${this.state.agent._id}/article/${article._id}`)} className="item">
              <div className="avatar">
                <img src={article.medias[0].images.big[0]}/>
              </div>
              <div className="title">
                <span className="name">{article.name}</span>
                &nbsp;&nbsp;描述：{article.desc}
              </div>
              <div className="clear"></div>
            </div>
          ))}
          {!this.state.articles.length?<div className="text-gray width-all height-100 lh-100 fz-14 text-center">~还没有合作行程~</div>:''}
          <div className="footer"></div>
        </div>
        <Navigator action='left' />
  	  </div>
  	);
  }
}

AgentComponent.displayName = 'AgentComponent';

export default AgentComponent;



// WEBPACK FOOTER //
// ./src/components/AgentComponent.js